import React, { useEffect, useRef, useState } from "react";
import { Button, Image, Modal, ModalHeader } from "react-bootstrap";
import {
  ModalBodyBlack,
  ModalHeaderBlack,
  MyModal,
} from "../../features/RadConnStyle";
import { setReminder } from "../../features/UserActions";
import { useDispatch } from "react-redux";
import axios from "axios";
import { HttpJsonHeader } from "../../features/Environments";

export default function ClipboardPaster(props) {
  const { showClipboard, setClipboard, userDetail, selectedRow } = props;
  const [cbImage, setCbImage] = useState();
  const dispatch = useDispatch();
  const imageRef = useRef(null);

  const handleClipboard = async (evt) => {
    // console.log(navigator);
    const permission = await navigator.permissions.query({
      name: "clipboard-read",
    });

    if (permission.state === "granted") {
      const clipboardContents = await navigator.clipboard.read();
      for (const item of clipboardContents) {
        if (!item.types.includes("image/png")) {
          throw new Error("Clipboard contains non-image data.");
        }
        const blob = await item.getType("image/png");
        setCbImage(blob);
      }
    } else {
      dispatch(
        setReminder({
          show: true,
          message: "ไม่ได้รับอนุญาตให้รับข้อมุลจาก Clipboard",
          type: "error",
        })
      );
    }
  };

  const blobToBase64 = () => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(cbImage);
    });
  };

  // handle upload
  const handleUpload = async (evt) => {
    console.log("....uploading.......");

    const formData = new FormData();
    let imageData = await blobToBase64();
    formData.append("user", JSON.stringify({ ...userDetail, uploadType: 2 })); // uploadType(1=file, 2=captured image, 3=scanned image)
    formData.append("rowdata", JSON.stringify(selectedRow));
    formData.append("image", JSON.stringify({ image: imageData }));

    axios
      .post(
        process.env.REACT_APP_API + "api/studyinfo/study-update-web-capture",
        formData,
        HttpJsonHeader
      )
      .then((res) => {
        if (res.data) {
          dispatch(
            setReminder({
              show: true,
              message: "Upload ไฟล์เสร็จสมบูรณ์",
              type: "success",
            })
          );
          if (showClipboard?.action) {
            showClipboard.action();
          }
        } else {
          dispatch(setReminder({ show: true, message: "การ Uplaod ผิดพลาด" }));
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    if (cbImage) {
      //console.log("..... cbImage OK ....");
      //console.log(cbImage);
    }
  }, [cbImage]);

  useEffect(() => {
    if (showClipboard?.show === false) {
      setCbImage(null);
    }
  }, [showClipboard?.show]);

  return (
    <MyModal
      show={showClipboard?.show}
      size="lg"
      centered
      fullscreen
      onHide={() => setClipboard({ show: false })}
    >
      <ModalHeader closeButton size="lg">
        <div style={{ color: "#ffffff" }}>{""}</div>
        <Button style={styles.button} onClick={handleClipboard}>
          {" "}
          Read From Clipboard
        </Button>

        {cbImage ? (
          <Button
            variant="success"
            style={styles.button}
            onClick={handleUpload}
          >
            {" "}
            Upload
          </Button>
        ) : (
          <></>
        )}
      </ModalHeader>
      {/* <div style={{ display: "flex", justifyContent: "end" }}>
          <Button onClick={handleClipboard}> Read From Clipboard</Button>
          <Button onClick={handleUpload}> Upload</Button>
        </div> */}
      <ModalBodyBlack>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "80vh",

            // overflow: "scroll",
          }}
        >
          <Image
            src={cbImage && URL.createObjectURL(cbImage)}
            alt="no-image"
            style={{
              border: "1px solid white",
              justifySelf: "center",
              alignContent: "center",
            }}
          ></Image>
        </div>
      </ModalBodyBlack>
    </MyModal>
  );
}

const styles = {
  button: {
    marginInline: "5px",
  },
};
